import { render, staticRenderFns } from "./PopupButtons.vue?vue&type=template&id=584325b0&"
import script from "./PopupButtons.vue?vue&type=script&lang=js&"
export * from "./PopupButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports